import React, { useEffect } from 'react'
import { ScrollableWithIndicator } from './ScrollableWithIndicator'
import { createPortal } from 'react-dom'
import { IconBase } from './svg/IconBase'
import type { ModalState } from '@store/atoms'
import { AppLoader } from '@src/App'
import LoaderMini from './LoaderMini'

const ModalRoot: React.FC<ModalState> = ({
	isOpen,
	onCloseModal,
	onCallBack,
	title,
	labelOk,
	labelClose,
	disableButton,
	disableButtonAdd,
	children,
	reverseButton,
	spreadButtons = false,
	hideClose = false,
	hideBorderLeft = false,
	height = 'h-[540px] md:h-[400px]',
	width = 'max-w-[calc(100%-32px)]  sm:max-w-[360px] md:max-w-[720px] lg:max-w-[1076px]',
	//width="max-w-[360px] md:max-w-[720px] lg:max-w-[1076px]",
	modalSpacingFromTop = 'pt-4 md:pt-24',
	//modalSpacingFromTop = 'pt-10 md:pt-24',
	loading = false,
	buttonLoading = false,
}) => {
	// Disabilita scroll del body quando la modale è aperta
	useEffect(() => {
		document.body.style.overflow = isOpen ? 'hidden' : ''
		return () => {
			document.body.style.overflow = ''
		}
	}, [isOpen])

	if (!isOpen) return null

	const content = typeof children === 'function' ? children() : children

	const closeButton = labelClose && (
		<button
			className={`btn-annulla ${disableButtonAdd ? 'text-(--border-top) bg-(--disabled) cursor-not-allowed' : null}`}
			disabled={disableButtonAdd}
			onClick={reverseButton ? onCallBack : onCloseModal}
		>
			{labelClose}
		</button>
	)

	const okButton = labelOk && (
		<div className='flex items-center gap-3'>
			{buttonLoading && <LoaderMini />}

			<button
				className={`
				w-fit font-bold md:px-4 px-5 py-3 md:py-2 rounded-[30px] transition
				${
					!disableButton && !buttonLoading
						? `text-white bg-(--green-default)
						   bg-linear-to-r from-(--green-default) to-(--green-hover)
						   shadow-[0_3px_10px_rgba(0,0,0,0.1)]
						   hover:underline`
						: 'text-(--border-top) bg-(--disabled) cursor-not-allowed'
				}
			`}
				onClick={reverseButton ? onCloseModal : onCallBack}
				disabled={disableButton || buttonLoading}
			>
				{labelOk}
			</button>
		</div>
	)

	return createPortal(
		<div
			className={`fixed inset-0 flex items-start ${modalSpacingFromTop} justify-center bg-(--background) bg-opacity-50 z-1000 px-2`}
		>
			{/* Contenitore principale della modale */}
			<div
				className={`bg-white
		p-2.5
		shadow-[0px_3px_10px_0px_#0000001A]
		w-full ${height} ${width}
		max-h-[calc(100vh-6rem)]
		relative
		overflow-hidden
		flex flex-col
		${hideBorderLeft ? 'border-l-20 border-(--strokes-orange)' : ''}`}
			>
				{/* Tasto di chiusura "X" */}

				<div className='flex justify-between'>
					<div></div>
					{!hideClose && (
						<button
							className='
						
                        group
                        w-11 h-11 md:w-11 md:h-11
                        flex items-center justify-center
                        rounded-full
                        text-(--green-default)
                        transition-all duration-300
                        hover:bg-(--green-default)
                        hover:text-white
                        '
							onClick={onCloseModal}
							disabled={false}
						>
							<IconBase
								className='w-full h-full transition-transform duration-300'
								icon={'M6 6L18 18M6 18L18 6'}
							/>
						</button>
					)}
				</div>

				{/* Intestazione della modale (Titolo e tasto X) */}
				<div className='flex justify-between items-center mb-4'>
					<div className='text-2xl md:text-[28px] text-(--primary-blue) font-semibold mx-6 md:mx-12'>
						{title}
					</div>
				</div>

				{/* Contenuto principale della modale */}

				<ScrollableWithIndicator
					wrapperClassName='flex-1 min-h-0 mx-6 md:mx-12 flex flex-col'
					className='flex-1 overflow-y-auto flex flex-col pb-2 min-h-0 pr-5 md:pr-2'
				>
					{loading ? <AppLoader /> : content}
				</ScrollableWithIndicator>

				{(closeButton || okButton) && (
					<div
						className={`
		 shrink-0
  		flex
  		${spreadButtons ? 'justify-between md:justify-end' : 'justify-end'}
  		items-end
  		gap-4
		pt-6 md:pt-4
		md:pb-5
		pb-2.5
		mx-6 md:mx-12
  		md:flex-row
  	${reverseButton ? 'flex-col-reverse' : ''}
   
			`}
					>
						{closeButton}
						{okButton}
					</div>
				)}
			</div>
		</div>,
		document.getElementById('modal-root')! // Assicurati di avere <div id="modal-root"></div> in index.html
	)
}

export default ModalRoot
